'use client'

import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'
import Script from 'next/script'
import { useEffect } from 'react'
import { globalStyles } from '../styles/style'
import RouteChangeProgress from './RouteChangeProgress'
import { initFirebaseModules } from '../firebase/helpers'

export default function RootClientComponent({
  children,
}: {
  children: React.ReactNode
}) {
  // サーバーサイドレンダリング時のデバッグログ
  if (typeof window === 'undefined') {
    console.log('Server-side rendering RootClientComponent - this should not happen');
  }

  // クライアントサイドでのみFirebaseモジュールを初期化
  useEffect(() => {
    if (typeof window !== 'undefined') {
      console.log('Initializing Firebase modules on client-side');
      initFirebaseModules()
    }
  }, [])
  // クライアントサイドでのキャッシュを作成
  const cache = createCache({ key: 'css' })
  
  return (
    <>
      <CacheProvider value={cache}>
        {globalStyles}
        <RouteChangeProgress />
        {children}
      </CacheProvider>
      
      <Script
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6183892803208880"
        id="Absence-banner"
        async
        crossOrigin="anonymous"
        strategy="afterInteractive"
        onError={(e) => {
          console.error('Script failed to load', e)
        }}
      />
    </>
  )
}